export const LOAD_CATEGORIES = 'LOAD_CATEGORIES'

